type AnalyticEventData = {
  /**
   * Optional. The component that triggered the event.
   */
  component?: string;
  /**
   * Optional. The call to action that triggered the event.
   */
  cta?: string;
  /**
   * Optional. The value of the metric.
   */
  metricValue?: number;
  /**
   * Optional. The type of the event.
   */
  type?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
};

type TrackWithDetailsProps = AnalyticEventData & {
  category?: string;
  event: string;
};

// Please be careful when updating. Locations are used across multiple events.
// This enum is also defined in static/ld/utils/analyticsUtils.ts.
// Keep both in sync when making changes.
enum EventLocation {
  FLAG_LIST = 'FlagList',
  FLAG_TARGETING = 'FlagTargeting',
  EXPERIMENT_LIST = 'ExperimentList',
  MEMBER_LIST = 'MemberList',
  METRIC_PAGE = 'MetricPage',
  METRIC_GROUP_PAGE = 'MetricGroupPage',
  // experiments tab on flags
  FLAG_EXPERIMENTS = 'FlagExperiments',
  TEAM_CUSTOM_ROLES = 'TeamCustomRoles',
  TEAMS = 'Teams',
  USER_FLAGS = 'UserFlags',
  FLAG_LINKS = 'FLagLinks',
  EDIT_METRIC = 'EditMetric',
  PAYLOAD_FILTERS = 'PayloadFilters',
  FLAGS_IN_SEGMENT = 'FlagsInSegment',
  TOP_NAV = 'TopNav',
  FLAG_INSIGHTS = 'FlagInsights',
  ACCOUNT_USAGE = 'AccountUsage',
  VIEW_LINKED_RESOURCES = 'ViewLinkedResources',
}

export type { AnalyticEventData, TrackWithDetailsProps };
export { EventLocation };
